// Money helpers for the web client. Money is always integer cents, never floats
// (.claude/rules/data-model-ledger.md). The one dollars<->cents parser for the web client, so every amount input
// uses the same proven conversion and the same buffering idiom.

export function parseDollarsToCents(input: string): number | null {
  const trimmed = input.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return null;
  const [dollars, centsPart = ''] = trimmed.split('.');
  const cents = (centsPart + '00').slice(0, 2);
  return parseInt(dollars, 10) * 100 + parseInt(cents, 10);
}

export function formatCentsAsDollars(cents: number | null): string {
  if (cents === null) return '';
  return (cents / 100).toFixed(2);
}

// Display-only formatter for read views: integer cents -> a grouped currency string
// (4959773 -> "$49,597.73"). Distinct from formatCentsAsDollars above, which the
// wizard's amount-input buffering depends on and which must keep returning a bare,
// unformatted "12345.67". This output is never parsed back into cents.
const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCentsAsCurrency(cents: number | null): string {
  if (cents === null) return '';
  return CURRENCY_FORMAT.format(cents / 100);
}
